<template>
  <div class="Acceptance">
    <!-- 受理概况 -->
    <div class="panel">
      <p class="title">受理概览</p>
      <div class="panel-item">
        <p class="p1">
          <img class="type-icon" src="../../../../assets/refund/icon_Reback@2x.png" alt />
          <span class="type-text">累计退货成功</span>
        </p>
        <p class="p2">
          {{ returnQuantityAndData.CumulativeReturnSucceeded || 0 }}
          <span>起</span>
        </p>
        <p class="p3">
          累计退货申请
          <span>{{ returnQuantityAndData.CumulativeReturnApplication || 0 }}</span> 起
        </p>
      </div>
      <div class="panel-item">
        <p class="p1">
          <img class="type-icon" src="../../../../assets/refund/icon_Amount@2x.png" alt />
          <span class="type-text">累计退款金额</span>
        </p>
        <p v-if="returnQuantityAndData" class="p2">
          {{ moneyFormat(returnQuantityAndData.CumulativeReturnSucceededMount || 0).num }}
          <span>{{ moneyFormat(returnQuantityAndData.CumulativeReturnSucceededMount || '元').unit }}</span>
        </p>
        <p class="p3">
          累计申请涉及金额
          <span>{{ moneyFormat(returnQuantityAndData.CumulativeReturnaMount || 0).num }}</span>{{ moneyFormat(returnQuantityAndData.CumulativeReturnaMount || '元').unit }}
        </p>
      </div>
      <div class="statistics-panel">
        <van-grid :column-num="2" :border="false" class="van-grid-1">
          <van-grid-item>
            <p class="p1">平均单起退货成功金额</p>
            <p class="p2">¥{{ moneyFormat(returnQuantityAndData.AverageReturnMount || 0).num }}{{ moneyFormat(returnQuantityAndData.AverageReturnMount || '元').unit}}</p>
          </van-grid-item>
          <van-grid-item>
            <p class="p1">平均每件商品退款金额</p>
            <p class="p2">¥{{ moneyFormat(returnQuantityAndData.AverageCommodityMount || 0).num }}{{ moneyFormat(returnQuantityAndData.AverageCommodityMount || '元').unit }}</p>
          </van-grid-item>
        </van-grid>
        <van-grid :column-num="2" :border="false">
          <van-grid-item>
            <p class="p1">平均响应时长</p>
            <p v-if="timeData" class="p2">{{ formatSeconds(timeData.responseTimeSec) || 0 }}</p>
          </van-grid-item>
          <van-grid-item>
            <p class="p1">平均达成共识时长</p>
            <p v-if="timeData" class="p2">{{ formatSeconds(timeData.reachConsensusSec) || 0 }}</p>
          </van-grid-item>
        </van-grid>
      </div>
    </div>

    <!-- 处理满意度分布情况 -->
    <div class="panel">
      <div class="header">
        <p class="title">处理满意度分布情况</p>
      </div>
      <div class="ChartBox">
        <dashboard-chart :dataset="touristEvaluationData" :title="'总评价数'" v-if="touristEvaluationData && touristEvaluationData.length > 0"  />
        <div v-else>暂无数据</div>
      </div>
      <van-grid :border="false" :column-num="3" class="processing-satisfaction">
        <van-grid-item v-for="(item, index) in touristEvaluationData" :key="index" @click="toCommonList(item, index)">
          <div class="type">
            <p class="round" :style="`background-color:${item.color}`"></p>
            <span>{{ item.type }}</span>
          </div>
          <p class="percentage">{{ item.proportion }}%</p>
          <div class="number">
            <span>{{ item.count || 0 }}起</span>
            <van-icon name="arrow" />
          </div>
        </van-grid-item>
      </van-grid>
    </div>
    
    <!-- 退货商品分布情况 -->
    <div class="panel">
      <div class="header">
        <p class="title">退货商品分布情况</p>
        <div class="showtype">
          <div
            @click="changeSort('按数量')"
            class="btn"
            :class="{'btn-active': CommodityDistributionShowType === '按数量'}"
          >按数量</div>
          <div
            @click="changeSort('按金额')"
            class="btn"
            :class="{'btn-active': CommodityDistributionShowType === '按金额'}"
          >按金额</div>
        </div>
      </div>
      <div v-if="commodityTypeData && commodityTypeData.length > 0" id="commodityDistribution" :style="{ height: '264px',width:'100%'}"></div>
      <div v-else>暂无数据</div>
    </div>
 
    <!-- 近30天退货数量同比趋势 -->
    <div class="panel">
      <div class="header">
        <p class="title">近30天退货数量同比趋势</p>
      </div>
      <p class="echarts-title">单位（起）</p>
      <div id="Nearly30days" :style="{ height: '230px',width:'100%'}"></div>
    </div>
  </div>
</template>

<script>
    import echarts from 'echarts';

    import Vue from 'vue';
    import { Sticky } from 'vant';
    import api from '../../../../service/modules/refund'
    import common from '../../../../utils/common'
    import dashboardChart from './chartComponent/dashboardChart.vue';

    Vue.use(Sticky);

    export default {
        filters: {
            moneyFilter (val) {
                if (val) {
                    return Number(val).toFixed(2)
                }
            }
        },
        data () {
            return {
                commodityDistributionEchartsOption: {},
                CommodityDistributionShowType: '按数量',
                commodityDistributionData: '', // 商品分布统计数据
                returnQuantityAndData: {},
                timeData: {},
                userInfo: {},
                commodityTypeData: [],
                touristEvaluationData: [],
                sort: 'count',
                appRefundNumCompareData: [],
                touristEvaluationColor: {
                    '满意': '#3BC07C',
                    '基本满意': '#66AEF8',
                    '不满意': '#FFB469'
                },
                params: {
                    dataType: '',
                    endTime:  this.$store.state.refund.statisticalAnalysisTime.endTime,
                    orgId: '',
                    reginCode: this.$store.state.refund.statisticalAnalysisReginCode,
                    sort: '',
                    startTime:  this.$store.state.refund.statisticalAnalysisTime.startTime,
                    value: ''
                }
            };
        },
        components: {
            dashboardChart
        },
        created () {
            this.currentUser();
        },
        mounted () {
            // this.CommodityDistributionEchartsInit();
            // this.Nearly30dayEchartsInit();
            // var myChart = echarts.init(
            //   document.getElementById("commodityDistribution")
            // );
            // window.onresize = function() {
            //   myChart.resize();
            // };
        },
        methods: {
            moneyFormat (val) {
                return common.numberFormat(val)
            },
            toCommonList (item, index) {
                let typeList = [];
                this.touristEvaluationData.forEach((item) => {
                    typeList.push({
                        F_NAME: item.type,
                        count: item.count
                    });
                })
                typeList.forEach((item) => {
                    switch (item.F_NAME) {
                    case '不满意':
                        item.comment = 1;
                        break;
                    // case '一般满意':
                    case '基本满意':
                        item.comment = 3;
                        break;
                    // case '非常满意':
                    case '满意':
                        item.comment = 5;
                        break;
                    }
                })
                sessionStorage.removeItem('optionList');
                sessionStorage.setItem('optionList', JSON.stringify(typeList));
                this.$router.push({
                    path: '/refund/commonList',
                    query: {
                        optionList: typeList,
                        activeIndex: index,
                        startTime: this.params.startTime,
                        endTime: this.params.endTime
                    }
                });
            },
            currentUser () {
                this.userInfo = {}
                api.currentUser().then(res => {
                    if (res.ret === 0) {
                        this.userInfo = res.data
                        // this.params.reginCode = this.userInfo.regionCode;
                        this.params.reginCode = this.$store.state.refund.statisticalAnalysisReginCode;
                        this.init()
                    } else {
                        this.userInfo = {}
                    }
                })
            },
            async init () {
                await this.returnQuantityAnd();
                await this.disposalEfficiency() // 获取时长
                await this.commodityType()
                await this.touristEvaluation()
                await this.appRefundNumCompare()
            },
            // 添加时间作为筛选条件
            async timeChange (time) {
                if (time.length != 0) {
                    this.params.startTime = time[0].replace(/\//g, '-');
                    this.params.endTime = time[1].replace(/\//g, '-');

                    this.$store.state.refund.statisticalAnalysisTime.startTime = time[0].replace(/\//g, '-');
                    this.$store.state.refund.statisticalAnalysisTime.endTime = time[1].replace(/\//g, '-');
          
                    this.params.dataType = 4
                }
                await this.init();
                this.areaOrTimeChangeCallBack()
            },
            async areaChange (area) {
                this.params.reginCode = area;
                this.$store.state.refund.statisticalAnalysisReginCode = area
                
                await this.init();
                this.areaOrTimeChangeCallBack()
            },
            areaOrTimeChangeCallBack() {
              // 如果退货成功数量和申请数量都是0，表示没数据
              if (this.returnQuantityAndData.CumulativeReturnSucceeded == '0'
                && this.returnQuantityAndData.CumulativeReturnApplication == '0'
              ) {
                this.$emit('nodata', true)
              } else {
                this.$emit('nodata', false)
              }
            },
            appRefundNumCompare () {
                this.appRefundNumCompareData = [];
                return api.appRefundNumCompare(this.params).then(r => {
                    if (r.ret === 0) {
                        this.appRefundNumCompareData = r.data
                    } else {
                        this.appRefundNumCompareData = {}
                    }
                    this.Nearly30dayEchartsInit()
                })
            },
            touristEvaluation () {
                this.touristEvaluationData = []
                return api.touristEvaluation(this.params).then(res => {
                    if (res.ret === 0) {
                        let touristEvaluationData = res.data.touristEvaluationMap;
                        if (touristEvaluationData && touristEvaluationData.length > 0) {
                            touristEvaluationData.forEach(i => {
                                i.color = this.touristEvaluationColor[i.type]
                            })
                            this.touristEvaluationData = touristEvaluationData;
                        }
                    } else {
                        this.touristEvaluationData = []
                    }
                })
            },
            commodityType () {
                this.commodityTypeData = []
                return api.commodityType(this.params).then(res => {
                    if (res.ret === 0) {
                        this.commodityTypeData = [];
                        if (res.data.commodityTypeMap && res.data.commodityTypeMap.length > 0) {
                            this.commodityTypeData = res.data.commodityTypeMap
                            this.CommodityDistributionEchartsInit();
                        }
                    } else {
                        this.commodityTypeData = []
                    }
                })
            },
            formatSeconds (time) {
                if (!time) {
                    return;
                }
                return common.formatSeconds(time)
            },
            disposalEfficiency () {
                this.timeData = {}
                return api.disposalEfficiency(this.params).then(res => {
                    if (res.ret === 0) {
                        this.timeData = res.data
                    } else {
                        this.timeData = {}
                    }
                })
            },
            returnQuantityAnd () {
                this.returnQuantityAndData = {}
                return api.returnQuantityAnd(this.params).then(res => {
                    if (res.ret === 0) {
                        this.returnQuantityAndData = res.data
                    } else {
                        this.returnQuantityAndData = {}
                    }
                });
            },
            // 近三十天图表
            Nearly30dayEchartsInit () {
                // 获取日期
                const days = []
                const curYearSeriesData = []
                const lastYearSeriesData = []
                const curYear = this.appRefundNumCompareData.curYear ? this.appRefundNumCompareData.curYear.year : null
                const lastYear = this.appRefundNumCompareData.lastYear ? this.appRefundNumCompareData.lastYear.year : null
                if (this.appRefundNumCompareData.curYear) {
                    this.appRefundNumCompareData.curYear.data.map(i => {
                        curYearSeriesData.push(i.num)
                        i.time = i.time.split('-').join('/')
                        days.push(i.time.substr(5))
                    })
                }
                if (this.appRefundNumCompareData.lastYear) {
                    this.appRefundNumCompareData.lastYear.data.map(i => {
                        lastYearSeriesData.push(i.num)
                    })
                }
                const option = {
                  grid: {
                    top: "20",
                    left: "8%",
                    containLabel: true
                  },
                    tooltip: {
                      // position: ['40%', '0%'],
                      position: function (point, params, dom, rect, size) {
                        // 当前鼠标位置
                        var pointX = point[0];
                        // 提示框大小
                        var boxWidth = size.contentSize[0];
                        return [pointX - boxWidth / 2, '0%']
                      },
                        trigger: 'axis',
                        triggerOn: 'click',
                        formatter: function (params) {
                          console.log('paramsparamsparams', params);
                            let template = '';
                            params.map((item) => {
                                template += `<div>${item.seriesName}/${item.axisValue}: ${item.value}起</div>`
                            })
                            return template;
                        }
                    },
                    color: ['#36B374', '#FF8C19'],
                    legend: {
                        y: 'bottom',
                        x: 'center',
                        itemHeight: 7
                    },
                    xAxis: {
                        axisTick: {
                            show: false // 不显示坐标轴刻度
                        },
                        axisLine: {
                            lineStyle: {
                                type: 'dashed',
                                color: '#E0E0E0'
                            }
                        },
                        axisLabel: {
                            fontSize: 12,
                            textStyle: {
                                color: '#71747A'
                            }
                        },
                        type: 'category',
                        boundaryGap: false,
                        // data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"]
                        data: days
                    },
                    yAxis: {
                      type: 'value',
                      name: '',
                      axisLabel: {
                          // formatter: '{value} °C'
                          fontSize: 12,
                          textStyle: {
                              color: '#C8C9CC'
                          }
                      },
                      axisLine: {
                          show: false
                      },
                      axisTick: {
                          show: false // 不显示坐标轴刻度
                      }
                    },
                    series: [
                        {
                            name: curYear,
                            type: 'line',
                            // data: [10, 11, 13, 11, 12, 12, 9],
                            data: curYearSeriesData,
                            markPoint: {
                                // data: [
                                //   { type: "max", name: "Max" },
                                //   { type: "min", name: "Min" }
                                // ]
                            }, // 转折点标记
                            markLine: {
                                // data: [{ type: "average", name: "Avg" }] // 平均线
                            }
                        },
                        {
                            name: lastYear,
                            type: 'line',
                            // data: [1, 0, 2, 5, 3, 2, 0],
                            data: lastYearSeriesData,
                            markPoint: {
                                // data: [{ name: "周最低", value: -2, xAxis: 1, yAxis: -1.5 }]
                            }
                        }
                    ],
                    dataZoom: [
                        {
                            type: 'inside', // slider表示有滑动块的，inside表示内置的
                            show: true,
                            xAxisIndex: [0],
                            start: 0,
                            end: 50,
                            backgroundColor: 'rgba(0,0,0,0.5)', // 滑块背景颜色
                            fillerColor: 'rgba(255,255,0,0.5)', // 填充颜色
                            showDetail: false // 拖拽时，是否显示详细信息
                        }
                    ]
                };
                const Nearly30dayEcharts = echarts.init(
                    document.getElementById('Nearly30days')
                );
                Nearly30dayEcharts.setOption(option);
            },
            // 切换商品分布情况图标显示类型，按金额、按数量
            changeSort (type) {
                this.CommodityDistributionShowType = type
                if (this.CommodityDistributionShowType === '按数量') {
                    this.sort = 'count'
                } else {
                    this.sort = 'amount'
                }
                this.commodityType()
            },
            CommodityDistributionEchartsInit (type) {
                const productTypes = ['普洱茶', '银制品', '药材', '其他', '珠宝玉石']
                const xAxisData = []
                const seriesData = []
                let isWanYuan = false
                let that = this
                if (this.sort === 'count') {
                    // 降序
                    this.commodityTypeData = this.commodityTypeData.sort((a, b) => {
                        return b.count - a.count
                    })
                    // 按数量
                    this.commodityTypeData.map(i => {
                        seriesData.push(i.count)
                        xAxisData.push(productTypes[i.type - 1])
                    })
                } else {
                    // 按金额
                    isWanYuan = this.commodityTypeData.some(i => i.amount > 10000)
                    // 降序
                    this.commodityTypeData = this.commodityTypeData.sort((a, b) => {
                        return b.amount - a.amount
                    })

                    if (isWanYuan) {
                        this.commodityTypeData.map(i => {
                            i.amount = (i.amount / 10000).toFixed(2)
                            seriesData.push(i.amount)
                            xAxisData.push(productTypes[i.type - 1])
                        })
                    } else {
                        this.commodityTypeData.map(i => {
                            seriesData.push(i.amount)
                            xAxisData.push(productTypes[i.type - 1])
                        })
                    }
                }
                // 每次切换类型重新画图表
                const option = {
                    grid: {
                        left: 50
                    },
                    tooltip: {
                      position: 'inside',
                      axisPointer: {
                        type: 'none' // 去掉点击出现的横线
                      },
                        trigger: 'item',
                        // trigger: 'axis',
                        triggerOn: 'click',
                        formatter: function (params) {
                            return `
              <div>${params.name}: ${params.value}${that.sort === 'count' ? '件' : isWanYuan ? '万元' : '元'}</div>
            `
                        }
                    },
                    xAxis: {
                        axisTick: {
                            show: false // 不显示坐标轴刻度
                        },
                        axisLine: {
                            lineStyle: {
                                type: 'dashed',
                                color: '#E0E0E0'
                            }
                        },
                        type: 'category',
                        // data: ["Mon", "Tue", "Wed"]
                        data: xAxisData,
                        axisLabel: {
                            interval: 0,
                            fontSize: 12,
                            textStyle: {
                                color: '#71747A'
                            }
                        }
                    },
                    yAxis: {
                        axisTick: {
                            show: false // 不显示坐标轴刻度
                        },
                        axisLabel: {
                            fontSize: 12,
                            textStyle: {
                                color: '#C8C9CC'
                            }
                        },
                        type: 'value',
                        name: this.sort === 'count' ? '单位（件）' : isWanYuan ? '单位（万元）' : '单位（元）',
                        nameTextStyle: {
                            color: '#C8C9CC',
                            padding: [0, 0, 5, 0] // 四个数字分别为上右下左与原位置距离
                        },
                        // max: seriesData[0],
                        splitNumber: 4, // 把刻度分为4段，刻度阙值就是总的/这个数
                        axisLine: {
                            show: false
                        }
                    },
                    series: [
                        {
                            // data: [200, 110, 100, 80, 70, 60, 50],
                            data: seriesData,
                            type: 'bar',
                            barWidth: 12,
                            itemStyle: {
                                normal: {
                                    color: '#36B374',
                                    label: {
                                        show: true, // 开启显示
                                        position: 'top', // 在上方显示
                                        textStyle: { // 数值样式
                                            color: '#36B374',
                                            fontSize: 12
                                        }
                                    }
                                }
                            }
                        }
                    ]
                };
                this.$nextTick(() => {
                    const commodityDistributionEchartsInit = echarts.init(
                        document.getElementById('commodityDistribution')
                    );
                    commodityDistributionEchartsInit.setOption(option);
                })
            }
        }
    };
</script>

<style lang="less" scoped>
.Acceptance {
  background-color: #f9fafc;
  padding: 12px 12px 90px;
  .panel {
    background-color: white;
    padding: 12px 16px 0;
    margin-bottom: 12px;
    .echarts-title {
      font-weight: 400;
      font-size: 12px;
      color: #C8C9CC;
    }
    .title {
      font-size: 16px;
      color: #1E2226;
      font-weight: bold;
      margin-bottom: 12px;
    }
    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .title {
        font-size: 16px;
        color: #1e2226;
        font-weight: bold;
      }
      .showtype {
        display: flex;
        div:first-child {
          border-radius: 2px 0 0 2px;
        }
        div:last-child {
          border-radius: 0 2px 2px 0;
        }
        .btn {
          border: 1px solid #36b374;
          width: 56px;
          padding: 6px 0;
          text-align: center;
          font-weight: 400;
          font-size: 12px;
          border-radius: 2px;
          color: #36b374;
        }
        .btn-active {
          background: #36b374;
          color: white;
        }
      }
    }
    /deep/.processing-satisfaction {
      .van-grid-item__content--center {
        .type {
          display: flex;
          width: 100%;
          align-items: center;
          line-height: 22px;
          .round {
            width: 8px;
            height: 8px;
            border-radius: 50%;
            margin-right: 6px;
            background-color: red;
          }
          .greenRound {
            background-color: #3BC07C;
          }
          .blurRound {
            background-color: #66AEF8;
          }
          .orangeRound {
            background-color: #FFB469;
          }
          span {
            font-size: 12px;
            color: #71747A;
            font-weight: 400;
          }
        }
        .percentage {
          font-weight: Bold;
          font-size: 14px;
          color: #1E2226;
          padding-left: 25px;
          line-height: 17px;
          width: 100%;
          margin-bottom: 4px;
        }
        .number {
          font-size: 12px;
          color: #71747A;
          font-weight: 400;
          display: flex;
          align-items: center;
          padding-left: 12px;
          line-height: 17px;
          width: 100%;
        }
      }
    }
    .panel-item {
      background-color: #f9fafc;
      padding: 16px;
      // margin-bottom: 12px;
      .p1 {
        font-size: 14px;
        color: #1e2226;
        line-height: 20px;
        display: flex;
        // align-items: center;
        img {
          width: 14px;
          height: 14px;
          margin-right: 3px;
          margin-top: 2px;
        }
      }
      .p2 {
        font-size: 20px;
        color: #1e2226;
        font-weight: bold;
        line-height: 24px;
        margin: 8px 0;
        span {
          font-size: 12px;
          color: #71747a;
          font-weight: 500;
        }
      }
      .p3 {
        font-size: 12px;
        color: #71747a;
        font-weight: 500;
        
        span {
          font-weight: 600;
          font-size: 14px;
          color: #1E2226;
        }
      }
    }
    /deep/.statistics-panel {
      background-color: white;
      padding: 20px 16px 16px;

      .van-grid-item:nth-child(even) {
        padding-left: 15px;
      }
      .van-grid-1 {
        margin-bottom: 20px;
      }
      .van-grid-item__content {
        padding: 0;
        align-items: flex-start;
        .p1 {
          font-size: 12px;
          color: #71747a;
          font-weight: 400;
          padding-left: 6px;
          line-height: 17px;
          &::before {
            content: "";
            display: inline-block;
            width: 2px;
            height: 10px;
            background-color: #36b374;
            position: relative;
            left: -6px;
          }
        }
        .p2 {
          margin-top: 2px;
          font-size: 14px;
          color: #1e2226;
          font-weight: 600;
          line-height: 17px;
          padding-left: 6px;
        }
      }
    }
  }
}
</style>
